<template>
    <moe-page>
        <moe-top ref="moeTop"></moe-top>
        <div class="test_paper_content flex Flexjustify">
            <div class="content flex FlexBetween">
                <div class="content_left">
                    <div class="catalog_details flex Flexalign p-10">
                        <el-image class="catalog_details_icon" :src="iconPath('catalog_details_icon.png')"></el-image>
                        <div class="ml-5">目录明细</div>
                    </div>
                    <div class="p-15 tree_box">
                        <el-tree ref="treeRef" :data="educationData" node-key="id" default-expand-all
                            :expand-on-click-node="true" :highlight-current="true" @node-click="handleNodeClick">
                            <template #icon="{ node }">
                                <span v-if="node.isLeaf" class="icon-leaf">📄</span>
                                <span v-else-if="node.expanded" class="icon-collapse">-</span>
                                <span v-else class="icon-expand">+</span>
                            </template>

                            <template #default="{ node, data }">
                                <span class="custom-tree-node" :class="{ 'highlight-text': isInPath(data.id) }">
                                    {{ node.label }}
                                </span>
                            </template>
                        </el-tree>
                    </div>
                </div>
                <div class="content_right mb-30">
                    <!-- 右侧内容保持不变 -->
                    <div class="right_top p-20">
                        <div class="filter_box flex">
                            <div class="filter_label">学科：</div>
                            <div class="filter_list flex FlexWrap flex-1">
                                <div class="filter_value ml-30 cursor_pointer" v-for="(item, index) in subjectList"
                                    :key="index" :class="[listParams.subjectId == item.subjectId ? 'text_active' : '']"
                                    @click="selectSubject(item)">
                                    {{ item.subjectName }}
                                </div>
                            </div>
                        </div>
                        <div class="filter_box flex mt-15 Flexalign">
                            <div class="filter_label">更多：</div>
                            <div class="filter_list flex FlexWrap flex-1">
                                <el-select class="ml-30" v-model="listParams.difficulty" placeholder="难易度"
                                    style="width: 90px" @change="getTestPaperList">
                                    <el-option v-for="item in difficultOptions" :key="item.value" :label="item.label"
                                        :value="item.value" />
                                </el-select>
                                <!-- <el-select class="ml-30" v-model="difficultValue" placeholder="轮次" style="width: 80px">
                                    <el-option v-for="item in difficultOptions" :key="item.value" :label="item.label"
                                        :value="item.value" />
                                </el-select>
                                <el-select class="ml-30" v-model="difficultValue" placeholder="阶段" style="width: 80px">
                                    <el-option v-for="item in difficultOptions" :key="item.value" :label="item.label"
                                        :value="item.value" />
                                </el-select> -->
                            </div>
                        </div>
                    </div>
                    <div class="right_bottom mt-20 px-15 py-30 scroll_y hidden_scroll">
                        <div class="test_paper_list" v-if="testPaperList.length">
                            <div class="test_paper_one pb-10 mb-15 flex Flexalign Flexbetween"
                                v-for="(item, index) in testPaperList" :key="index">
                                <el-image class="test_paper_cover_icon"
                                    :src="iconPath('test_paper_cover_icon.svg')"></el-image>
                                <div class="paper_info flex flexcolumn ml-15">
                                    <div class="toverflow paper_name">{{ item.paperAppraisalName }}</div>
                                    <div class="paper_tag flex mt-15">
                                        <div class="tag_one px-10 py-5 mr-10">
                                            {{gradeList.filter(sitem => sitem.stageId == item.stageId)[0]?.stageName}}
                                        </div>
                                        <div class="tag_one px-10 py-5 mr-10">
                                            {{gradeList.filter(sitem => sitem.gradeId == item.gradeId)[0]?.gradeName}}
                                        </div>
                                        <div class="tag_one px-10 py-5 mr-10">
                                            {{originSubjectList.filter(sitem => sitem.subjectId ==
                                                item.subjectId)[0]?.subjectName}}
                                        </div>
                                    </div>
                                    <div class="flex Flexalign paper_create mt-15">
                                        <div>{{ $Moment(item.updateTime).format("MM-DD") }}发布</div>
                                        <div class="ml-30">题量：{{ item.questionCount }}</div>
                                        <div class="ml-30">总分：{{ item.totalScore }}</div>
                                        <div class="ml-30">创建人：{{ item.businessUserName }}</div>
                                    </div>
                                </div>
                                <div class="paper_difficult ml-50 flex flexcolumn FlexEnd">
                                    <el-rate v-model="item.difficulty" disabled :max="7" size="large" />
                                    <div class="btn_start cursor_pointer" @click="beginExam(item)">开始考试</div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <moe-empty url="moe_empty_bg_img.png" emptyText="暂无测评"></moe-empty>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </moe-page>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "GjkcH5Index",
    computed: {
        ...mapState({
            originSubjectList: (state) => state.filter.subjectList,
            gradeList: (state) => state.filter.gradeList,
        }),
    },

    data() {
        return {
            educationData: [],
            highlightPath: "",
            currentSelectedNodeId: null, // 当前选中的节点ID
            difficultOptions: [
                {
                    label: "全部",
                    value: '',
                },
                {
                    label: "一星",
                    value: 1,
                },
                {
                    label: "二星",
                    value: 2,
                },
                {
                    label: "三星",
                    value: 3,
                },
                {
                    label: "四星",
                    value: 4,
                },
                {
                    label: "五星",
                    value: 5,
                },
                {
                    label: "六星",
                    value: 6,
                },
                {
                    label: "七星",
                    value: 7,
                },
            ],
            difficultValue: "",
            testPaperList: [],
            listParams: {
                stageId: '',
                gradeId: '',
                subjectId: '',
                difficulty: '',
            },
            subjectList: [],
            topSelectedMenu: ''
        };
    },

    mounted() {
        this.topSelectedMenu = this.$Jump.getUrlParams(
            window.location.hash.split("?")[1]
        ).topSelectedMenu;
        this.$refs.moeTop.topSelectedMenu = this.topSelectedMenu;
        this.handleGradeList();
        this.getSubjectList();
        // this.getTestPaperList();
    },

    methods: {
        // 处理年级数据
        handleGradeList() {
            const stageMap = {};

            this.gradeList.forEach(item => {
                if (!stageMap[item.stageId]) {
                    stageMap[item.stageId] = {
                        id: parseInt(item.stageId) + 1000,
                        label: item.stageName,
                        stageId: item.stageId,
                        type: 'stage',
                        children: []
                    };
                }

                stageMap[item.stageId].children.push({
                    id: parseInt(item.gradeId),
                    label: item.gradeName,
                    gradeId: item.gradeId,
                    stageId: item.stageId,
                    type: 'grade'
                });
            });

            this.educationData = Object.values(stageMap);
        },

        handleNodeClick(data, node) {
            console.log("节点被点击:", data, node);

            // 判断是否是取消选中同一节点
            if (this.currentSelectedNodeId === data.id) {
                // 取消选中
                this.cancelSelection();
                return;
            }

            // 选中新节点
            this.currentSelectedNodeId = data.id;

            // 获取从根节点到当前节点的路径
            this.highlightPath = this.getNodePath(node);
            console.log("高亮路径:", this.highlightPath);

            // 手动更新高亮状态
            this.updateHighlight();

            // 调用加载试卷方法，传入当前节点数据
            this.loadTestPapers(data, node);
        },

        // 新增：取消选中的方法
        cancelSelection() {
            this.currentSelectedNodeId = null;
            this.highlightPath = [];
            this.listParams.stageId = '';
            this.listParams.gradeId = '';
            this.listParams.subjectId = '';

            // 清除树的高亮状态
            this.updateHighlight();

            // 清除el-tree的当前选中状态
            if (this.$refs.treeRef) {
                this.$refs.treeRef.setCurrentKey(null);
            }

            // 重新获取学科列表和试卷列表
            this.getSubjectList();
            this.getTestPaperList();

            console.log("已取消选中");
        },

        getNodePath(node) {
            const path = [];
            let currentNode = node;

            while (currentNode) {
                path.unshift(currentNode.data.id);
                currentNode = currentNode.parent;
            }

            return path;
        },

        updateHighlight() {
            // 移除所有高亮类
            const allNodes = document.querySelectorAll(".el-tree-node");
            allNodes.forEach((node) => {
                node.classList.remove("highlight-path");
            });

            // 如果有高亮路径，为路径中的节点添加高亮类
            if (this.highlightPath.length > 0) {
                this.highlightPath.forEach((nodeId) => {
                    const nodeElement = document.querySelector(`[data-node-id="${nodeId}"]`);
                    if (nodeElement) {
                        nodeElement.classList.add("highlight-path");
                    }
                });
            }
        },

        isInPath(nodeId) {
            return this.highlightPath.includes(nodeId);
        },

        // 修改：加载对应年级的试卷
        loadTestPapers(data) {
            let stageId = null;
            let gradeId = null;

            if (data.type === 'stage') {
                stageId = data.stageId;
                gradeId = null;
            } else if (data.type === 'grade') {
                stageId = data.stageId;
                gradeId = data.gradeId;
            }

            this.listParams.stageId = stageId;
            this.listParams.gradeId = gradeId;
            this.listParams.subjectId = '';
            this.getSubjectList();
            this.getTestPaperList();
        },

        // 其他方法保持不变...
        getSubjectList() {
            this.$Api.common
                .getSubject({ stageId: this.listParams.stageId })
                .then((res) => {
                    this.subjectList = res.data.data;
                    this.listParams.subjectId = this.subjectList[0].subjectId;
                    this.getTestPaperList();
                })
                .catch(() => { });
        },

        selectSubject(info) {
            this.listParams.subjectId = info.subjectId;
            this.getTestPaperList();
        },
        // 获取测评列表
        getTestPaperList() {
            this.$Api.testPaper.getTestPaperList(this.listParams).then(res => {
                this.testPaperList = res.data.data;
            }).catch(() => { })
        },
        // 开始考试
        beginExam(info) {
            this.href("/examStart", { paperInfo: JSON.stringify(info), paperType: 'testPaper' });
        }
    },
};
</script>

<style lang="scss" scoped>
.test_paper_content {
    width: 100%;
    background: #f3f3f3;
    padding-top: 20px;
    min-height: calc(100vh - 60px);
    box-sizing: border-box;

    .content {
        width: $pageMainWidth;

        .content_left {
            width: 267px;
            /* 稍微增加宽度以适应更大的内容 */
            height: 810px;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;

            .catalog_details {
                font-weight: 500;
                font-size: 16px;
                color: #111111;
                border-bottom: 1px solid rgba(0, 0, 0, 0.1);

                .catalog_details_icon {
                    width: 22px;
                    height: 22px;
                }
            }

            .tree_box {
                height: 760px;
                overflow: auto;
                box-sizing: border-box;

                /* 增大树节点文字 */
                :deep(.el-tree-node__content) {
                    height: 40px;
                    /* 增加节点高度 */
                    font-size: 16px;
                    /* 增大字体 */
                }

                /* 当前选中节点的高亮 */
                :deep(.el-tree-node.is-current>.el-tree-node__content .custom-tree-node) {
                    color: #13d6aa !important;
                    font-weight: bold;
                }

                /* 增大展开/收起图标 */
                :deep(.el-tree-node__expand-icon) {
                    width: 20px !important;
                    /* 增大图标容器宽度 */
                    height: 20px !important;
                    /* 增大图标容器高度 */
                    font-size: 18px;
                    /* 增大图标字体大小 */
                }

                :deep(.el-tree-node__expand-icon > .el-icon) {
                    font-size: 18px;
                    /* 确保图标本身也增大 */
                }

                .el-tree :deep(.el-tree-node__expand-icon.expanded) {
                    -webkit-transform: rotate(0deg);
                    transform: rotate(0deg);
                }

                //有子节点 且未展开 - 增大背景图标
                .el-tree :deep(.el-tree-node__expand-icon:before) {
                    background: url("/public/static/icon/catalog_add_icon.png") no-repeat 0;
                    content: "";
                    display: block;
                    width: 24px;
                    /* 增大宽度 */
                    height: 24px;
                    /* 增大高度 */
                    font-size: 24px;
                    background-size: 20px;
                    /* 增大背景图片尺寸 */
                }

                :deep(.el-icon svg) {
                    display: none;
                }

                //有子节点 且已展开 - 增大背景图标
                .el-tree :deep(.el-tree-node__expand-icon.expanded:before) {
                    background: url("/public/static/icon/catalog_reduce_icon.png.png") no-repeat 0;
                    content: "";
                    display: block;
                    width: 24px;
                    /* 增大宽度 */
                    height: 24px;
                    /* 增大高度 */
                    font-size: 24px;
                    background-size: 20px;
                    /* 增大背景图片尺寸 */
                }

                //没有子节点 - 增大叶子节点图标
                .el-tree :deep(.el-tree-node__expand-icon.is-leaf::before) {
                    background: none;
                    content: "";
                    display: block;
                    width: 20px;
                    /* 增大宽度 */
                    height: 20px;
                    /* 增大高度 */
                    font-size: 20px;
                }

                /* 增大自定义图标 */
                :deep(.icon-leaf),
                :deep(.icon-collapse),
                :deep(.icon-expand) {
                    font-size: 18px;
                    /* 增大图标字体 */
                    margin-right: 6px;
                    /* 增加右边距 */
                }
            }
        }

        .content_right {
            .right_top {
                width: 913px;
                min-height: 105px;
                background: #ffffff;
                border-radius: 10px;
                box-sizing: border-box;

                :deep(.el-select__wrapper) {
                    box-shadow: none;
                }
            }

            .right_bottom {
                width: 913px;
                height: 700px;
                background: #ffffff;
                border-radius: 10px;
                box-sizing: border-box;

                .test_paper_list {
                    .test_paper_one {
                        border-bottom: 1px solid rgba(0, 0, 0, 0.1);

                        .test_paper_cover_icon {
                            width: 92px;
                            height: 104px;
                        }

                        .paper_info {
                            width: 550px;
                            height: 104px;

                            .paper_name {
                                width: 100%;
                                font-weight: 500;
                                color: #303030;
                            }

                            .paper_tag {
                                .tag_one {
                                    background: #eff1f4;
                                    border-radius: 4px;
                                    font-size: 11px;
                                    color: #606060;
                                }
                            }

                            .paper_create {
                                font-size: 12px;
                                color: #606060;
                            }
                        }

                        .paper_difficult {
                            .btn_start {
                                width: 91px;
                                height: 32px;
                                background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
                                border-radius: 8px;
                                text-align: center;
                                line-height: 32px;
                                font-size: 14px;
                                color: #ffffff;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
